import React from 'react';
import { useLanguage } from '../components/context/LanguageContext';
import './Tours.css';
import torontoImage from '../images/toronto.avif';
import vancouverImage from '../images/vancouverI.avif';

const Tours = () => {
  const { t } = useLanguage();

  const tourCategories = [
    {
      id: 'worldcup',
      name: 'United States',
      tours: [
        // 🔒 ძველი ამერიკის ტურის ვერსიები (შენახული, დაკომენტარებული)
        // {
        //   id: 1,
        //   name: "World Cup Final Experience",
        //   location: "New York/New Jersey, USA",
        //   description: "VIP package for the 2026 World Cup Final at MetLife Stadium. Includes premium tickets, hotel, and exclusive events",
        //   duration: "7 days",
        //   price: "???",
        //   image: "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
        //   highlights: ["World Cup Final Ticket", "VIP Hospitality", "5-Star Hotel", "Player Meet & Greet", "Official Merchandise"]
        // },
        // {
        //   id: 2,
        //   name: "World Cup Group Stage Package", 
        //   location: "Los Angeles & Dallas, USA",
        //   description: "Follow your favorite team through the group stages in two iconic American cities with premium seating",
        //   duration: "10 days",
        //   price: "???",
        //   image: "https://images.unsplash.com/photo-1529900748604-07564a03e7a6?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
        //   highlights: ["3 Group Stage Matches", "Cross-City Travel", "Stadium Tours", "Fan Zone Access", "Team Base Visit"]
        // },
        // {
        //   id: 3,
        //   name: "World Cup Quarter Finals Experience",
        //   location: "Miami & Atlanta, USA", 
        //   description: "Experience the knockout stage intensity with quarter final matches in two southern powerhouse cities",
        //   duration: "8 days",
        //   price: "???",
        //   image: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
        //   highlights: ["2 Quarter Final Tickets", "Beach Party Events", "Southern Cuisine Tour", "Stadium VIP Access", "Official FIFA Events"]
        // },

        // ⭐ ახალი World Cup ტური (აშშ) — შენი აღწერით
        {
          id: 10,
          name: "მოგზაურობა აშშ-ში • 2026 მსოფლიო ჩემპიონატზე",
          location: "ნიუ-იორკი • ბოსტონი • ფილადელფია",
          description:
            "ექსკლუზიური ჯგუფური ტური, რომელიც შექმნილია იმისთვის, რომ მსოფლიო ჩემპიონატი უმაღლესი კომფორტითა და პრემიალური სერვისით იგრძნოთ. თქვენი მოგზაურობა სრულად კურირებულია ჩვენი გუნდის მიერ — დაწყებული მატჩებზე წვდომით, დამთავრებული უწყვეტი მხარდაჭერით ამერიკაში ყოფნის პერიოდში.",
          duration: "12–28 ივნისი",
          price: "",
          image:
            "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
          highlights: [
            "სრული სავიზო მომსახურება",
            "ჯგუფური ეტაპის 3 მატჩზე დასწრება",
            "ორმხრივი ავიაბილეთები",
            "სასტუმრო • 12–28 ივნისი",
            "ტრასფერი თამაშებზე",
            "E-SIM სერვისის გააქტიურება",
            "ჯგუფის WhatsApp/Telegram ჩატი",
            "სამოგზაურო დაზღვევა",
            "ადგილობრივი პარტნიორები",
            "ინდივიდუალური მოთხოვნების შესრულება",
            "სპეციალური საჭიროების სერვისი",
            "24/7 მხარდაჭერა ჯგუფისთვის"
          ]
        }
      ]
    },
    {
      id: 'canada',
      name: 'Canada',
      tours: [
        // 🔒 ძველი კანადის იდეები (შესაძლებელია მომავალში ჩართო)
        // {
        //   id: 4,
        //   name: "Canadian Rockies Explorer",
        //   location: "Banff & Vancouver, Canada",
        //   description: "Discover the stunning beauty of the Canadian Rockies with guided hikes, wildlife watching, and mountain resorts",
        //   duration: "8 days",
        //   price: "???", 
        //   image: vancouverImage,
        //   highlights: ["Lake Louise Visit", "Wildlife Safari", "Mountain Hiking", "Hot Springs", "Glacier Tour"]
        // },
        // {
        //   id: 5,
        //   name: "East Canada Metropolis Tour",
        //   location: "Toronto & Montreal, Canada",
        //   description: "Experience Canada's vibrant east coast cities with cultural tours, culinary experiences, and Niagara Falls",
        //   duration: "6 days",
        //   price: "???",
        //   image: torontoImage,
        //   highlights: ["Niagara Falls", "CN Tower", "Old Montreal", "Distillery District", "French Cuisine"]
        // }
      ]
    },
    {
      id: 'uk',
      name: 'United Kingdom',
      tours: [
        // 🔒 ძველი ინგლისის წინა ვარიანტები
        // {
        //   id: 6,
        //   name: "London Royal Experience",
        //   location: "London, United Kingdom", 
        //   description: "Immerse yourself in British royalty and history with palace tours, afternoon tea, and West End shows",
        //   duration: "5 days",
        //   price: "???",
        //   image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
        //   highlights: ["Buckingham Palace", "West End Show", "Afternoon Tea", "British Museum", "Thames River Cruise"]
        // },
        // {
        //   id: 7, 
        //   name: "UK Countryside & Castles",
        //   location: "Scotland & Wales, UK",
        //   description: "Explore ancient castles, rugged highlands, and picturesque villages across Scotland and Wales",
        //   duration: "7 days",
        //   price: "???",
        //   image: "https://images.unsplash.com/photo-1485081669829-bacb8c7bb1f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
        //   highlights: ["Edinburgh Castle", "Scottish Highlands", "Welsh Castles", "Loch Ness", "Traditional Pubs"] 
        // }

        // ⭐ ახალი ლონდონის ტური — რომ არაფერი არ დაიკარგოს ინფოდან
        {
          id: 20,
          name: "მოგზაურობა ლონდონში • 2026",
          location: "ლონდონი, გაერთიანებული სამეფო",
          description:
            "ექსკლუზიური ტური, რომელიც გაძლევთ შესაძლებლობას ლონდონის კულტურას, არქიტექტურასა და ქალაქის უნიკალურ ენერგიას შეეხოთ. მთელი მოგზაურობა წარმართულია უმაღლესი კლასის კომფორტით და დახვეწილი ორგანიზებით.",
          duration: "5–9 მაისი",
          price: "",
          image:
            "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
          highlights: [
            "სრული სავიზო მომსახურება",
            "ორმხრივი ავიაბილეთები",
            "სასტუმრო 5–9 მაისი",
            "ტრასფერი აეროპორტიდან/აეროპორტამდე",
            "E-SIM სერვისის გააქტიურება",
            "ჯგუფის WhatsApp/Telegram ჩატი",
            "ტური ლონდონის მთავარ ღირსშესანიშნაობებზე",
            "სამოგზაურო დაზღვევა",
            "ადგილობრივი პარტნიორები",
            "ინდივიდუალური მოთხოვნების შესრულება",
            "სპეციალური საჭიროების სერვისი",
            "24/7 მხარდაჭერა ჯგუფისთვის"
          ]
        }
      ]
    }
  ];

  const handleBookNow = (tour) => {
    const message = `I'm interested in booking: ${tour.name} (${tour.location})`;
    window.location.href = `/contact?tour=${encodeURIComponent(
      tour.name
    )}&message=${encodeURIComponent(message)}`;
  };

  return (
    <div className="tours-page">
      <div className="tours-hero">
        <h1>{t('ourTours')}</h1>
        <p>{t('chooseExperience')}</p>
      </div>

      <div className="container">
        {tourCategories.map((category) => (
          <section key={category.id} className="tour-category">
            <h2 className="category-title">{category.name} Tours</h2>

            <div className="tours-grid">
              {category.tours.length === 0 ? (
                <p className="coming-soon">Coming Soon...</p>
              ) : (
                category.tours.map((tour) => (
                  <div key={tour.id} className="tour-card">
                    <div className="tour-image">
                      <img src={tour.image} alt={tour.name} />
                      <div className="tour-price">${tour.price}</div>
                    </div>

                    <div className="tour-info">
                      <h3>{tour.name}</h3>
                      <p className="tour-location">📍 {tour.location}</p>
                      <p className="tour-description">{tour.description}</p>

                      <div className="tour-highlights">
                        <h4>Highlights:</h4>
                        <ul>
                          {tour.highlights.map((highlight, index) => (
                            <li key={index}>✓ {highlight}</li>
                          ))}
                        </ul>
                      </div>

                      <div className="tour-details">
                        <span className="duration">⏱ {tour.duration}</span>
                        <button
                          className="book-button"
                          onClick={() => handleBookNow(tour)}
                        >
                          {t('bookNow')}
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Tours;